import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import moment from "moment-timezone";

export default function UtmSourceTypeCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let utmSourceId = decode.id;
    let utmId = decode.utmId;
    let utmTitle = decode.utmTitle;
    let utmSourceTitle = decode.utmSourceTitle;

    let backPath = '/utmSourceType/' + Utils.encodeItem({id: utmSourceId, utmId: utmId, utmTitle: utmTitle, utmSourceTitle: utmSourceTitle});

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [owner, setOwner] = React.useState('');
    const navigate = useNavigate();

    let refName = React.useRef();
    let refDetail = React.useRef();
    let refCode = React.useRef();

    let [utmSourceData, setUtmSourceData] = React.useState('');
    React.useEffect(() => {
        (async function() {
            try {
                const resView = await getUtmSourceView();
                setUtmSourceData(resView);
                const resOwner = await Utils.getOwner();
                setOwner(resOwner);

                if(resView.isEncrypt) {
                    const resCode = await getLastCode(resView.id);
                    if(resCode && resCode.code) {
                        let code = parseInt(resCode.code);
                        let newCode = code + 1;
                        if(newCode.toString().length === 1) {
                            refCode.current.value = '000' + newCode;
                        }
                        else if(newCode.toString().length === 2) {
                            refCode.current.value = '00' + newCode;
                        }
                        else if(newCode.toString().length === 3) {
                            refCode.current.value = '0' + newCode;
                        }
                        else {
                            refCode.current.value = newCode;
                        }
                    }
                    else {
                        refCode.current.value = '0001';
                    }
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getLastCode(utmSourceId) {
        const response = await fetch(Config.url.API_URL +'/api/utmSourceType/lastCode', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                utmSourceId: utmSourceId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getUtmSourceView() {
        const response = await fetch(Config.url.API_URL +'/api/utmSource/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: utmSourceId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = () => {
        let name = refName.current.value; 
        let detail = refDetail.current.value;
        let code = refCode.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ " + utmSourceTitle);
            refName.current.focus();
        }
        else if(utmSourceData.isEncrypt && code === '') {
            toast.error("กรุณาระบุ Code เป็นตัวเลข 4 หลัก");
            refCode.current.focus();
        }
        else if(utmSourceData.isEncrypt && code !== '' && (isNaN(code) || code.length !== 4)) {
            toast.error("กรุณาระบุ Code เป็นตัวเลข 4 หลัก");
            refCode.current.focus();
        }
        else {
            let items = [];
            let checkboxes = document.getElementsByName('ownerIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'ownerId': checkboxes[i].value});
                }
            }
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                name: name.toString().trim(),
                                detail: detail ?? null,
                                utmId: utmSourceData.utmId,
                                utmSourceId: utmSourceId,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items
                            };
                            if(utmSourceData?.isEncrypt) {
                                body.code =  code?.toString().trim();
                            }
                            fetch(Config.url.API_URL +'/api/utmSourceType/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(backPath, {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master UTM Format</div>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{utmTitle}</span>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{utmSourceTitle}</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">{utmSourceTitle} <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="detail" className="form-label">รายละเอียด</label>
                                <input type="text" className="form-control" id="detail" ref={refDetail} maxLength={100} />
                            </div>
                            <div className={"col-12" + (utmSourceData.isEncrypt === 1 ? '':' d-none')}>
                                <label htmlFor="detail" className="form-label">Code  <span className="text-danger">*</span></label><span className="float-end small text-muted">{utmSourceTitle} is Encrypt</span>
                                <div className="input-group">
                                    <div className="input-group-text">{utmSourceData.prefix}</div>
                                    <input type="text" className="form-control" id="name" ref={refCode} maxLength={4} placeholder="ระบุ Code" readOnly={false} />
                                </div>
                                <p className="my-1 text-danger small">ตัวเลข 4 หลัก</p>
                            </div>

                            <div className="col-12">
                                <label htmlFor="ownerx" className="form-label">สังกัด (Owner)</label>
                                {
                                    owner.length <= 0 ? (<p>ไม่พบสังกัด</p>) :
                                        owner.map((row, index) => {
                                            let chkId = 'ownerCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check">
                                                    <input className="form-check-input" name="ownerIds[]" type="checkbox" value={row.id}
                                                           id={chkId} />
                                                    <label className="form-check-label" htmlFor={chkId}>
                                                        ({row.code}) {row.name}
                                                    </label>
                                                </div>);
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to={backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 